import axios from "axios";

const RAW_BASE_URL = process.env.REACT_APP_BACKEND_URL || "/api";
const BASE_URL = RAW_BASE_URL.endsWith("/api") ? RAW_BASE_URL : `${RAW_BASE_URL}/api`;

// Single axios instance shared across the app.
// `withCredentials: true` lets the browser send & store the HTTPOnly
// `access_token` / `refresh_token` cookies that the FastAPI backend issues.
export const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Fallback for environments where third-party cookies are blocked: keep the
// access token in memory + localStorage and attach it as a Bearer header.
const TOKEN_KEY = "hscis_access_token";

export const setAccessToken = (token) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
};

export const getAccessToken = () => localStorage.getItem(TOKEN_KEY);

api.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
